"use strict";

export default {
    isFetchingEchecks: false,
    echecks: [],
};
